// src/pages/StudentReport.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import SummaryApi from '../common/index';
import { Eye, Download, X } from 'lucide-react';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const StudentReport = () => {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [consultancies, setConsultancies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [enrollmentSearch, setEnrollmentSearch] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [selectedYear, setSelectedYear] = useState('All');
  const [selectedConsultancy, setSelectedConsultancy] = useState('All');
const [selectedCourse, setSelectedCourse] = useState('All'); // ADD THIS
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;

  const [userType, setUserType] = useState('Admin');
  const [currentUserAdminId, setCurrentUserAdminId] = useState(null);

  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showModal, setShowModal] = useState(false);
const [showVerifyModal, setShowVerifyModal] = useState(false);
const [receiveReferenceNumber, setReceiveReferenceNumber] = useState("");
  const displayValue = (value) => {
    if (value === null || value === undefined || value === '' || value === '-') {
      return 'N/A';
    }
    return value;
  };

  useEffect(() => {
    const adminId = sessionStorage.getItem('admin_id');
const memberType = sessionStorage.getItem('member_type')?.toLowerCase();

    if (!adminId) {
      setError('Admin ID not found in session. Please login again.');
      setLoading(false);
      return;
    }

    setCurrentUserAdminId(adminId);
   setUserType(
  memberType?.toLowerCase() === 'consultancy'
    ? 'Consultancy'
    : 'Admin'
);

    if (memberType === 'Consultancy' && adminId) {
      setSelectedConsultancy(adminId);
    }
  }, []);
  const showConsultancyColumn = userType === 'Admin' && selectedConsultancy === 'All';
  useEffect(() => {
    if (!currentUserAdminId) return;


    fetchData();
  }, [selectedConsultancy, userType, currentUserAdminId]);
  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const consRes = await fetch(SummaryApi.consultancyname.url, {
        method: SummaryApi.consultancyname.method,
        headers: { 'Content-Type': 'application/json' },
      });

      if (consRes.ok) {
        const consResult = await consRes.json();
        if (consResult.status === true && Array.isArray(consResult.data)) {
          setConsultancies(consResult.data);
        }
      }

      let studentList = [];

      if (userType === 'Consultancy') {
        const studentsRes = await fetch(SummaryApi.getstudentsbyconsultant.url, {
          method: SummaryApi.getstudentsbyconsultant.method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ admin_id: currentUserAdminId }),
        });

        if (studentsRes.ok) {
          const result = await studentsRes.json();
          if (result.status === true && Array.isArray(result.data)) {
            studentList = result.data.map(mapStudent);
          }
        }
      } else {
        if (selectedConsultancy === 'All') {
          const studentsRes = await fetch(SummaryApi.getstudentAll.url, {
            method: SummaryApi.getstudentAll.method,
            headers: { 'Content-Type': 'application/json' },
          });

          if (studentsRes.ok) {
            const result = await studentsRes.json();
            if (result.status === true && Array.isArray(result.data)) {
              studentList = result.data.map(mapStudent);
            }
          }
        } else {
          const studentsRes = await fetch(SummaryApi.getstudentsbyconsultant.url, {
            method: SummaryApi.getstudentsbyconsultant.method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ admin_id: selectedConsultancy }),
          });

          if (studentsRes.ok) {
            const result = await studentsRes.json();
            if (result.status === true && Array.isArray(result.data)) {
              studentList = result.data.map(mapStudent);
            }
          }
        }
      }

      setStudents(studentList);
    } catch (err) {
      console.error('Fetch error:', err);
      setError('Failed to load student records. Please check connection or login.');
    } finally {
      setLoading(false);
    }
  };
const handleExportExcel = () => {

  if (filteredStudents.length === 0) {
    toast.error("No data available to export");
    return;
  }

  const exportData = filteredStudents.map((student, index) => ({
    "S.No": index + 1,
    "Enrollment Number": displayValue(student.student_enrollment_number),
    "Full Name": displayValue(student.full_name),
    "Category": displayValue(student.category),
    "Religion": displayValue(student.religion),
    "Caste": displayValue(student.caste),
    "DOB": student.dob ? new Date(student.dob).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-') : 'N/A',
    "Gender": displayValue(student.gender),
    "Mother Name": displayValue(student.mother_name),
    "Mobile Number": displayValue(student.mobile_number),
    "Parent Mobile Number": displayValue(student.parent_mobile_number),
    "Email": displayValue(student.email),
    "Aadhar Number": displayValue(student.aadhar),
    "Address Line 1": displayValue(student.address_line1),
    "State": displayValue(student.state),
    "City": displayValue(student.city),
    "District": displayValue(student.district),
    "Pincode": displayValue(student.pincode),
    "10th Board": displayValue(student.tenth_board),
    "10th Year Passing": displayValue(student.tenth_year_passing),
    "10th Percentage": displayValue(student.tenth_percentage),
    "12th Board Name": displayValue(student.twelfth_board_name),
    "12th Year Passing": displayValue(student.twelfth_year_passing),
    "12th Percentage/CGPA": displayValue(student.twelfth_percentage_cgpa),
    "12th Branch": displayValue(student.twelfth_branch),
    "Entrance Exam Name": displayValue(student.entrance_exam_name),
    "Preferred Branch": displayValue(student.btech_preffered_branch),
    "Consultancy Name": displayValue(student.consultancy_name),
    "Application Fee": displayValue(student.application_fee),
    "Platform Fee": displayValue(student.platform_fee),
    "Total Amount": displayValue(student.total_amount),
    "Reference Number": displayValue(student.reference_number),
    "Payment Status": student.is_paid === "1" ? "Paid" : "Unpaid",
    "Payment Verified": student.is_payment_complete === "1" ? "Verified" : "Pending",
    "Payment Created Date": displayValue(student.payment_created_date ? formatDateTime(student.payment_created_date) : 'N/A'),
    "Receive Reference Number": displayValue(student.payment_receive_reference_number),
    "Payment Updated Date": displayValue(student.payment_updated_date ? formatDateTime(student.payment_updated_date) : 'N/A'),
    "Registered On": displayValue(student.registered_on)
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Student Report");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(data, `Student_Report_${Date.now()}.xlsx`);
};
  const formatDateTime = (dateValue) => {
    if (!dateValue || dateValue === 'N/A') return 'N/A';

    const date = new Date(dateValue);
    if (isNaN(date)) return 'N/A';

    const pad = (num) => num.toString().padStart(2, '0');

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };
  const mapStudent = (item) => ({
    ...item,
    full_name: item.full_name || item.student_name || 'N/A',
    student_enrollment_number:
      item.student_enrollment_number || item.registration_number || item.enrollment_no || 'N/A',

    branch: item.twelfth_branch || 'N/A',
    year: item.twelfth_year_passing
      ? `${item.twelfth_year_passing} (Inter)`
      : 'N/A',

    // ✅ Keep raw date for filtering
    created_date_raw: item.created_date || null,

    // Only for display
    registered_on: item.created_date
      ? new Date(item.created_date).toLocaleString('en-IN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
      : 'N/A',

    consultancy_name: item.consultancy_name,
  });

  const parseDate = (dateStr) => {
    if (!dateStr || dateStr === 'N/A') return null;
    const parts = dateStr.split(/[-/]/);
    if (parts.length !== 3) return null;
    const [dd, mm, yyyy] = parts;
    return new Date(`${yyyy}-${mm}-${dd}`);
  };

const filteredStudents = students.filter((student) => {
  const searchValue = enrollmentSearch.toLowerCase().trim();
  const matchesSearch =
    searchValue === '' ||
    (student.full_name || '').toLowerCase().includes(searchValue) ||
    (student.mobile_number || '').toLowerCase().includes(searchValue) ||
    (student.student_enrollment_number || '').toLowerCase().includes(searchValue);

  let matchesDate = true;
  if (student.created_date_raw) {
    const studentDate = new Date(student.created_date_raw);
    if (fromDate) {
      const from = new Date(fromDate);
      from.setHours(0, 0, 0, 0);
      matchesDate = matchesDate && studentDate >= from;
    }
    if (toDate) {
      const to = new Date(toDate);
      to.setHours(23, 59, 59, 999);
      matchesDate = matchesDate && studentDate <= to;
    }
  }

  const matchesYear =
    selectedYear === 'All' || student.year.includes(selectedYear);

  // ADD THIS
  const matchesCourse =
    selectedCourse === 'All' ||
    (student.btech_preffered_branch || '').toLowerCase() === selectedCourse.toLowerCase();

  return matchesSearch && matchesDate && matchesYear && matchesCourse;
});
  const totalPages = Math.ceil(filteredStudents.length / itemsPerPage);
  const currentStudents = filteredStudents.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleEditStudent = (studentId) => {
    if (!studentId) return toast.error("Cannot edit: Student ID missing");
    const encodedId = btoa(studentId.toString());
    navigate(`/student-registration?id=${encodedId}`);
  };

  const handlePayNow = (student) => {
    if (!student.student_id) return toast.error("Cannot process payment: Student ID missing");
    const encodedId = btoa(student.student_id.toString());
    const encodedName = btoa((student.full_name || 'Unknown').trim());
    navigate(`/create-studentfee?id=${encodedId}&name=${encodedName}`);
  };

  const handleViewMore = (student) => {
    setSelectedStudent(student);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedStudent(null);
  };

  // Download using your exact backend logic
  const handleDownload = async (fileName, studentId, desiredFileName = 'document') => {
    if (!fileName || fileName === 'N/A' || !fileName.trim() || !studentId) {
      toast.error("Missing file name or student ID");
      return;
    }

    const base = SummaryApi.downloadfiles?.url;
    if (!base) {
      toast.error("Download endpoint not configured");
      return;
    }

    const downloadUrl = `${base}?student_id=${encodeURIComponent(studentId)}&file=${encodeURIComponent(fileName)}`;

    try {
      const response = await fetch(downloadUrl, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(`Server responded: ${response.status} ${response.statusText}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = desiredFileName;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success(`Downloading ${desiredFileName}...`);
    } catch (err) {
      console.error("Download failed:", err);
      toast.error("Download failed. Check CORS, student_id or file existence.");
    }
  };

  const handleDownloadAll = async (student) => {
    const files = [
      { file: student.photograph?.split('/').pop(), name: `Photo_${student.full_name || 'student'}.png` },
      { file: student.ssc_memo?.split('/').pop(), name: `SSC_Memo_${student.full_name || 'student'}` },
      { file: student.inter_first_year_memo?.split('/').pop(), name: `Inter_1st_${student.full_name || 'student'}` },
      { file: student.inter_second_year_memo?.split('/').pop(), name: `Inter_2nd_${student.full_name || 'student'}` },
    ];

    let count = 0;
    for (const doc of files) {
      if (doc.file && doc.file !== 'N/A' && doc.file.trim()) {
        await handleDownload(doc.file, student.student_id, doc.name);
        count++;
      }
    }

    if (count === 0) {
      toast.error("No valid documents found to download");
    } else {
      toast.success(`Started downloading ${count} file(s)`);
    }
  };

  const handleDownloadPaymentProof = (student) => {
    const fileName = student.payment_proof?.split('/').pop();
    if (!fileName || fileName === 'N/A') {
      toast.error("No payment proof available to download");
      return;
    }

    handleDownload(
      fileName,
      student.student_id,
      `Payment_Proof_${student.full_name || 'student'}_${student.reference_number || 'ref'}`
    );
  };

const clearAllFilters = () => {
  setEnrollmentSearch('');
  setFromDate('');
  setToDate('');
  setSelectedYear('All');
  setSelectedCourse('All'); // ADD THIS

  if (userType === 'Consultancy') {
    setSelectedConsultancy(currentUserAdminId || 'All');
  } else {
    setSelectedConsultancy('All');
  }
  setCurrentPage(1);
};

useEffect(() => {
  setCurrentPage(1);
}, [enrollmentSearch, fromDate, toDate, selectedYear, selectedCourse]); // add selectedCourse here
const handleVerifyPayment = async () => {

  if (!receiveReferenceNumber.trim()) {
    toast.error("Please enter Receive Reference Number");
    return;
  }

  if (!selectedStudent?.payment_id) {
    toast.error("Payment ID missing");
    return;
  }

  try {
    const response = await fetch(SummaryApi.paymentcompletedupdate.url, {
      method: SummaryApi.paymentcompletedupdate.method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        payment_id: selectedStudent.payment_id,
        is_payment_complete: "1",
        receive_reference_number: receiveReferenceNumber
      }),
    });

    const result = await response.json();

if (result.status === true) {

  toast.success("Payment verified successfully");

  // Update only receive reference number locally
setSelectedStudent(prev => ({
  ...prev,
  payment_receive_reference_number: receiveReferenceNumber,
  is_payment_complete: "1",
  payment_updated_date: new Date().toISOString()
}));

  // Close verify modal
  setShowVerifyModal(false);
  setReceiveReferenceNumber("");

  // 🔄 Refetch data so is_payment_complete comes from backend
  fetchData();

} else {
  toast.error(result.message || "Failed to verify payment");
}

  } catch (error) {
    console.error(error);
    toast.error("Something went wrong");
  }
};


  const handlePreview = async (fileName, studentId) => {
    if (!fileName || fileName === 'N/A' || !fileName.trim() || !studentId) {
      toast.error("Missing file name or student ID");
      return;
    }

    const base = SummaryApi.downloadfiles?.url;
    if (!base) {
      toast.error("Preview endpoint not configured");
      return;
    }

    const previewUrl = `${base}?student_id=${encodeURIComponent(studentId)}&file=${encodeURIComponent(fileName)}`;

    try {
      const response = await fetch(previewUrl);
      if (!response.ok) throw new Error("Failed to fetch file");

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      window.open(blobUrl, "_blank");

    } catch (err) {
      toast.error("Preview failed");
      console.error(err);
    }
  };
const totalColumns = 6 + (showConsultancyColumn ? 1 : 0) + 1 + (userType === 'Admin' ? 2 : 0);
  return (
    <div className="max-w-[98%] mx-auto px-4 py-6">
 <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
  
  <h2 className="text-2xl font-bold text-gray-800">
    Student Enrollment & Billing Report
  </h2>

  {userType === 'Admin' && (
  <button
    onClick={handleExportExcel}
    className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-md font-medium transition"
  >
    Export Excel
  </button>
  )}

</div>

      {/* Filters - Removed Search Bar, Added Enrollment Number Search */}
      <div className="mb-6 flex flex-col sm:flex-row flex-wrap gap-4 items-end">
        <div className="flex-1 min-w-[280px]">
          <input
            type="text"
            placeholder="Search by Full Name & Mobile no..."
            value={enrollmentSearch}
            onChange={(e) => { setEnrollmentSearch(e.target.value); setCurrentPage(1); }}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div className="flex flex-wrap gap-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">From Date</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => { setFromDate(e.target.value); setCurrentPage(1); }}
              className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">To Date</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => { setToDate(e.target.value); setCurrentPage(1); }}
              className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Year</label>
            <select
              value={selectedYear}
              onChange={(e) => { setSelectedYear(e.target.value); setCurrentPage(1); }}
              className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="All">All Years</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
            </select>
          </div> */}

   {userType === 'Admin' && (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">Consultancy</label>
    <select
      value={selectedConsultancy}
      onChange={(e) => { setSelectedConsultancy(e.target.value); setCurrentPage(1); }}
      className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 min-w-[220px]"
    >
      <option value="All">All Consultancies</option>
      {consultancies.map((cons) => (
        <option
          key={cons.admin_id || cons.consultant_id || cons.id}
          value={cons.admin_id || cons.consultant_id || cons.id || 'Unknown'}
        >
          {cons.consultancy_name || cons.consultant_name || cons.name || 'Unknown'}
        </option>
      ))}
    </select>
  </div>
)}

{/* ADD THIS BLOCK BELOW THE CONSULTANCY DROPDOWN */}
{userType === 'Admin' && (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">Preferred Course</label>
    <select
      value={selectedCourse}
      onChange={(e) => { setSelectedCourse(e.target.value); setCurrentPage(1); }}
      className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 min-w-[200px]"
    >
      <option value="All">All Courses</option>
      {[...new Set(
        students
          .filter(s =>
            selectedConsultancy === 'All' ||
            String(s.admin_id) === String(selectedConsultancy) ||
            String(s.consultant_id) === String(selectedConsultancy)
          )
          .map(s => s.btech_preffered_branch)
          .filter(Boolean)
      )].sort().map(course => (
        <option key={course} value={course}>{course}</option>
      ))}
    </select>
  </div>
)}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1"> </label>
            <button
              onClick={clearAllFilters}
              className="px-4 py-2 mt-5 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-md font-medium transition"
            >
              Clear Filters
            </button>
          </div>
        </div>
      </div>

      {loading && (
        <div className="text-center py-12 text-lg font-medium text-gray-700">
          Loading student records...
        </div>
      )}

      {error && (
        <div className="mb-6 p-4 bg-red-50 border border-red-200 text-red-700 rounded-lg">
          {error}
        </div>
      )}

      {!loading && !error && (
        <>
          <div className="overflow-x-auto bg-white shadow-lg rounded-xl border border-gray-200">
            <table className="min-w-full divide-y divide-gray-200 text-sm">
              <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
                <tr>
                  <th className="px-5 py-4 text-left font-semibold text-gray-800 w-16">S.No</th>
                  <th className="px-5 py-4 text-left font-semibold text-gray-800">Full Name</th>
                  <th className="px-5 py-4 text-left font-semibold text-gray-800">Mobile</th>
                  {showConsultancyColumn && (
                    <th className="px-5 py-4 text-left font-semibold text-gray-800">Consultancy Name</th>
                  )}
                  <th className="px-5 py-4 text-left font-semibold text-gray-800">
                    Preferred Course
                  </th>
                  <th className="px-5 py-4 text-left font-semibold text-gray-800">Registered On</th>
                  <th className="px-5 py-4 text-left font-semibold text-gray-800">Payment Status</th>
          {userType === 'Admin' && (
  <>
    <th className="px-5 py-4 text-left font-semibold text-gray-800">
      Payment Verified
    </th>

    <th className="px-5 py-4 text-left font-semibold text-gray-800">
      Verified On
    </th>
  </>
)}
                  <th className="px-5 py-4 text-center font-semibold text-gray-800 w-28">View More</th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100 bg-white">
                {currentStudents.length === 0 ? (
                  <tr>
                    <td colSpan={totalColumns} className="px-6 py-16 text-center text-gray-600 font-medium whitespace-pre-line">
                      {students.length === 0
                        ? "No students found"
                        : "No matching records found for current filters.\nTry changing enrollment number, year or date range."}
                    </td>
                  </tr>
                ) : (
                  currentStudents.map((student, index) => (
                    <tr
                      key={student.student_id ? `${student.student_id}-${index}` : `row-${index}`}
                      className="hover:bg-blue-50 transition-colors"
                    >
                      <td className="px-5 py-4 text-center font-medium text-gray-900">
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>

                      <td className="px-5 py-4 font-medium text-gray-900">
                        {displayValue(student.full_name)}
                      </td>
                      <td className="px-5 py-4">{displayValue(student.mobile_number)}</td>
                      {showConsultancyColumn && (
                        <td className="px-5 py-4">{displayValue(student.consultancy_name)}</td>
                      )}
                      <td className="px-5 py-4">{displayValue(student.btech_preffered_branch)}</td>
                      <td className="px-5 py-4">{displayValue(student.registered_on)}</td>
                      <td className="px-5 py-4">
                        <span
                          className={`inline-block px-2 py-1 text-xs font-medium rounded-full ${
                            student.is_paid === "1"
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {student.is_paid === "1" ? "Paid" : "Unpaid"}
                        </span>
                      </td>
             {userType === 'Admin' && (
  <>
    <td className="px-5 py-4">
      <span
        className={`inline-block px-2 py-1 text-xs font-medium rounded-full ${
          student.is_payment_complete === "1"
            ? "bg-green-100 text-green-800"
            : "bg-yellow-100 text-yellow-800"
        }`}
      >
        {student.is_payment_complete === "1" ? "Verified" : "Pending"}
      </span>
    </td>

    <td className="px-5 py-4 text-sm text-gray-700">
      {student.is_payment_complete === "1"
        ? formatDateTime(student.payment_updated_date)
        : "N/A"}
    </td>
  </>
)}



                      <td className="px-5 py-4 text-center">
                        <button
                          onClick={() => handleViewMore(student)}
                          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded-md text-sm font-medium transition flex items-center justify-center gap-1 mx-auto"
                        >
                          <Eye size={16} /> View
                        </button>
                        {(!student.is_paid || student.is_paid === "0" || student.is_paid === 0) && (
                          <button
                            onClick={() => handlePayNow(student)}
                            className="bg-yellow-600 hover:bg-yellow-700 text-white px-4 mt-2 rounded-md text-sm font-medium transition"
                          >
                            Pay Now
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="flex flex-col sm:flex-row justify-between items-center mt-6 gap-4">
            <button
              onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
              disabled={currentPage === 1 || currentStudents.length === 0}
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-2.5 rounded-md font-medium disabled:opacity-50 transition"
            >
              Previous
            </button>

            <span className="text-gray-700 font-medium">
              Page {currentPage} of {totalPages || 1} ({filteredStudents.length} records)
            </span>

            <button
              onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
              disabled={currentPage === totalPages || currentStudents.length === 0}
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-2.5 rounded-md font-medium disabled:opacity-50 transition"
            >
              Next
            </button>
          </div>
        </>
      )}

      {/* Modal with updated download calls */}
      {showModal && selectedStudent && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto">
<div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center z-10">
  <h3 className="text-xl font-bold text-gray-800">
    Student Details - {displayValue(selectedStudent.full_name)}
    {userType === 'Admin' && selectedStudent?.student_id && (
      <span className="ml-3 text-base font-normal text-gray-600">
        (Student ID: {selectedStudent.student_id})
      </span>
    )}
  </h3>

  <div className="flex items-center gap-3">
    {userType === "Admin" && (
      <button
        onClick={() => handleEditStudent(selectedStudent.student_id)}
        className="bg-green-600 hover:bg-green-700 text-white px-4 py-1.5 rounded-md text-sm font-medium transition"
      >
        Edit
      </button>
    )}
    <button
      onClick={closeModal}
      className="text-gray-600 hover:text-gray-900"
    >
      <X size={18} />
    </button>
  </div>
</div>

            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Personal Info */}
              <div>
                <h4 className="font-semibold text-gray-700 mb-3">Personal Information</h4>
                <div className="space-y-2 text-sm">
                  <p><strong>Consultancy Name:</strong> {displayValue(selectedStudent.consultancy_name)}</p>
                  <p><strong>Full Name:</strong> {displayValue(selectedStudent.full_name)}</p>
                   <p><strong>Category:</strong> {displayValue(selectedStudent.category)}</p>
                  <p><strong>Religion:</strong> {displayValue(selectedStudent.religion)}</p>
               <p><strong>Caste:</strong> {displayValue(selectedStudent.caste)}</p>
                  <p>
                    <strong>DOB:</strong>{" "}
                    {new Date(selectedStudent.dob).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }).replace(/ /g, "-")}
                  </p>
                  <p><strong>Gender:</strong> {displayValue(selectedStudent.gender)}</p>

                  <p><strong>Mother Name:</strong> {displayValue(selectedStudent.mother_name)}</p>
                                    <p><strong>Mobile:</strong> {displayValue(selectedStudent.mobile_number)}</p>
                                        <p><strong>Email:</strong> {displayValue(selectedStudent.email)}</p>
                  <p><strong>Parent Mobile:</strong> {displayValue(selectedStudent.parent_mobile_number)}</p>
              
                  <p><strong>Aadhar:</strong> {displayValue(selectedStudent.aadhar)}</p>  
                  <p><strong>Preferred Course:</strong> {displayValue(selectedStudent.btech_preffered_branch)}</p>

                </div>
              </div>

              {/* Address + Education */}
              <div>
                <h4 className="font-semibold text-gray-700 mb-3">Address</h4>
                <div className="space-y-2 text-sm mb-6">
                  <p><strong>Address:</strong> {displayValue(selectedStudent.address_line1)}</p>
                        <p><strong>State:</strong> {displayValue(selectedStudent.state)}</p>
                  <p><strong>City</strong> {displayValue(selectedStudent.city)} </p>           
     <p><strong>District:</strong>{displayValue(selectedStudent.district)} </p>
                  <p><strong>Pincode:</strong> {displayValue(selectedStudent.pincode)}</p>
                </div>

                <h4 className="font-semibold text-gray-700 mb-3">Education</h4>
                <div className="space-y-2 text-sm">
                  <p><strong>10th Board:</strong> {displayValue(selectedStudent.tenth_board)}</p>
                  <p><strong>10th Year / %:</strong> {displayValue(selectedStudent.tenth_year_passing)} / {displayValue(selectedStudent.tenth_percentage)}</p>
                  <p><strong>12th Board:</strong> {displayValue(selectedStudent.twelfth_board_name)}</p>
                  <p><strong>12th Year / %:</strong> {displayValue(selectedStudent.twelfth_year_passing)} / {displayValue(selectedStudent.twelfth_percentage_cgpa)}</p>
                  <p><strong>Branch:</strong> {displayValue(selectedStudent.twelfth_branch)}</p>
                  <p><strong>Entrance Exam:</strong> {displayValue(selectedStudent.entrance_exam_name)}</p>
                </div>
              </div>
              <div className="md:col-span-2 mt-8">
                <h4 className="font-semibold text-gray-700 mb-4 border-b pb-2">Payment Information</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

  <div>
    <p className="text-sm font-medium text-gray-600">Application Fee</p>
    <p className="mt-1 font-semibold">₹{displayValue(selectedStudent.application_fee)}</p>
  </div>

  <div>
    <p className="text-sm font-medium text-gray-600">Platform Fee</p>
    <p className="mt-1 font-semibold">₹{displayValue(selectedStudent.platform_fee)}</p>
  </div>

  <div>
    <p className="text-sm font-medium text-gray-600">Total Amount</p>
    <p className="mt-1 font-bold text-green-700">₹{displayValue(selectedStudent.total_amount)}</p>
  </div>

  <div>
    <p className="text-sm font-medium text-gray-600">Reference Number</p>
    <p className="mt-1">{displayValue(selectedStudent.reference_number)}</p>
  </div>

  <div>
    <p className="text-sm font-medium text-gray-600">Payment Status</p>
    <p className="mt-1">
      <span
        className={`inline-block px-3 py-1 text-xs font-medium rounded-full ${
          selectedStudent.is_paid === "1"
            ? "bg-green-100 text-green-800"
            : "bg-yellow-100 text-yellow-800"
        }`}
      >
        {selectedStudent.is_paid === "1" ? "Paid" : "Unpaid"}
      </span>
    </p>
  </div>

  <div>
    <p className="text-sm font-medium text-gray-600">Payment Date</p>
    <p className="mt-1">
      {formatDateTime(selectedStudent.payment_created_date)}
    </p>
  </div>

  {/* ✅ ADMIN ONLY FIELDS */}
  {userType === "Admin" && (
    <>
      <div>
        <p className="text-sm font-medium text-gray-600">
          Received Reference Number
        </p>
        <p className="mt-1">
          {displayValue(selectedStudent.payment_receive_reference_number)}
        </p>
      </div>

      <div>
        <p className="text-sm font-medium text-gray-600">
          Payment Verified On
        </p>
        <p className="mt-1">
          {formatDateTime(selectedStudent.payment_updated_date)}
        </p>
      </div>
    </>
  )}

</div>
              </div>
              {/* Documents Section */}
              {/* Documents Section */}
            <div className="md:col-span-2 mt-4">
  <h4 className="font-semibold text-gray-700 mb-4">Documents</h4>
  
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    {[
      { key: 'photograph', label: 'Photograph' },
      { key: 'aadhar_image', label: 'Aadhaar Card' },
      { key: 'ssc_memo', label: 'SSC Memo' },
      { key: 'inter_first_year_memo', label: 'Inter 1st Year' },
      { key: 'inter_second_year_memo', label: 'Inter 2nd Year' },
    ].map((doc) => {
      // Safer filename extraction
      const filePath = selectedStudent[doc.key];
      let filename = null;

      if (filePath && typeof filePath === 'string' && filePath.trim()) {
        filename = filePath.split('/').pop()?.trim() || null;
        if (filename === 'N/A' || filename === '-' || filename === '') {
          filename = null;
        }
      }

      return (
        <div key={doc.key} className="border rounded-lg p-4 bg-gray-50">
          <p className="font-medium mb-2">{doc.label}</p>
          {filename ? (
            <div className="flex gap-3">
              {/* View Button */}
              <button
                onClick={() => handlePreview(filename, selectedStudent.student_id)}
                className="flex items-center gap-1 text-green-600 hover:text-green-800 text-sm"
              >
                <Eye size={16} /> View
              </button>
              {/* Download Button */}
              <button
                onClick={() =>
                  handleDownload(
                    filename,
                    selectedStudent.student_id,
                    `${doc.label.replace(/\s+/g, '_')}_${selectedStudent.full_name || 'student'}`
                  )
                }
                className="flex items-center gap-1 text-blue-600 hover:text-blue-800 text-sm"
              >
                <Download size={16} /> Download
              </button>
            </div>
          ) : (
            <p className="text-gray-500 text-sm">Not Available</p>
          )}
        </div>
      );
    })}
  </div>

  {/* Payment Proof - now with View + Download like other documents */}
  <div className="mt-8">
    <h5 className="font-semibold text-gray-700 mb-3">Payment Proof</h5>
    
    {(() => {
      const proofPath = selectedStudent.payment_proof;
      let proofFilename = null;

      if (proofPath && typeof proofPath === 'string' && proofPath.trim()) {
        proofFilename = proofPath.split('/').pop()?.trim() || null;
        if (proofFilename === 'N/A' || proofFilename === '-' || proofFilename === '') {
          proofFilename = null;
        }
      }

      if (proofFilename) {
        return (
          <div className="border rounded-lg p-4 bg-gray-50 inline-block min-w-[280px]">
            <p className="font-medium mb-2">Payment Proof Document</p>
            <div className="flex gap-4">
              <button
                onClick={() => handlePreview(proofFilename, selectedStudent.student_id)}
                className="flex items-center gap-1 text-green-600 hover:text-green-800 text-sm"
              >
                <Eye size={16} /> View
              </button>
              <button
                onClick={() =>
                  handleDownload(
                    proofFilename,
                    selectedStudent.student_id,
                    `Payment_Proof_${selectedStudent.full_name || 'student'}_${selectedStudent.reference_number || 'ref'}`
                  )
                }
                className="flex items-center gap-1 text-blue-600 hover:text-blue-800 text-sm"
              >
                <Download size={16} /> Download
              </button>
            </div>
          </div>
        );
      }

      return (
        <p className="text-gray-500 text-sm italic">
          No payment proof uploaded
        </p>
      );
    })()}
  </div>
</div>
              {/* Payment Information */}

            </div>

            <div className="sticky bottom-0 bg-gray-50 border-t px-6 py-4 flex justify-between items-center">

              <div>
                {userType === "Admin" && (
                  selectedStudent?.is_payment_complete === "1" ? (
                    <span className="px-4 py-2 text-green-800 bg-green-100 rounded-md font-medium">
                      Payment Verified
                    </span>
                  ) : (
                    selectedStudent?.payment_id && (
            <button
  onClick={() => setShowVerifyModal(true)}
                        className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium transition"
                      >
                        Verify Payment
                      </button>
                    )
                  )
                )}
              </div>


            </div>
          </div>
        </div>
      )}






{showVerifyModal && (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 w-[400px] shadow-lg">

      <h3 className="text-lg font-semibold mb-4">
        Enter Receive Reference Number
      </h3>

      <input
        type="text"
        value={receiveReferenceNumber}
        onChange={(e) => setReceiveReferenceNumber(e.target.value)}
        placeholder="Enter reference number"
        className="w-full border px-3 py-2 rounded-md mb-4"
      />

      <div className="flex justify-end gap-3">

        <button
          onClick={() => {
            setShowVerifyModal(false);
            setReceiveReferenceNumber("");
          }}
          className="px-4 py-2 bg-gray-300 rounded-md"
        >
          Cancel
        </button>

        <button
          onClick={handleVerifyPayment}
          className="px-4 py-2 bg-blue-600 text-white rounded-md"
        >
          Submit
        </button>

      </div>

    </div>
  </div>
)}












    </div>








  );
};

export default StudentReport;